module.exports = __webpack_public_path__ + "static/media/wall-cyan.48752a70.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wall-cyan.png
// module id = 141
// module chunks = 0